import { gql } from '@apollo/client';

// 메인 카테고리 조회 (includeInactive: true 시 관리자용으로 비활성 포함)
export const GET_MAIN_CATEGORIES = gql`
  query GetMainCategories($includeInactive: Boolean) {
    mainCategories(includeInactive: $includeInactive) {
      id
      name
      description
      bannerImage
      bannerUrl
      order
      isActive
      createdAt
      updatedAt
      subCategoryCount
      productCount
      subCategories {
        id
        name
        description
        bannerImage
        bannerUrl
        order
        isActive
        productCount
      }
    }
  }
`;

// 기존 호환성을 위한 alias
export const GET_CATEGORIES_QUERY = GET_MAIN_CATEGORIES;

// 특정 메인 카테고리 조회
export const GET_MAIN_CATEGORY = gql`
  query GetMainCategory($id: ID!) {
    mainCategory(id: $id) {
      id
      name
      description
      bannerImage
      bannerUrl
      order
      isActive
      createdAt
      updatedAt
      subCategoryCount
      productCount
      subCategories {
        id
        name
        description
        bannerImage
        bannerUrl
        order
        isActive
        productCount
      }
      products {
        id
        name
        description
        specifications
        price
        discountPrice
        stock
        images
        isActive
        createdAt
        updatedAt
        mainCategoryId
        subCategoryId
      }
    }
  }
`;

// 하위 카테고리 조회 (includeInactive: true 시 관리자용으로 비활성 포함)
export const GET_SUB_CATEGORIES = gql`
  query GetSubCategories($mainCategoryId: String, $includeInactive: Boolean) {
    subCategories(mainCategoryId: $mainCategoryId, includeInactive: $includeInactive) {
      id
      name
      description
      bannerImage
      bannerUrl
      order
      isActive
      createdAt
      updatedAt
      productCount
      mainCategory {
        id
        name
      }
      products {
        id
        name
        description
        specifications
        price
        discountPrice
        stock
        images
        isActive
        createdAt
        updatedAt
        mainCategoryId
        subCategoryId
      }
    }
  }
`;

// 특정 하위 카테고리 조회
export const GET_SUB_CATEGORY = gql`
  query GetSubCategory($id: ID!) {
    subCategory(id: $id) {
      id
      name
      description
      bannerImage
      bannerUrl
      order
      isActive
      createdAt
      updatedAt
      productCount
      mainCategory {
        id
        name
      }
      products {
        id
        name
        description
        specifications
        price
        discountPrice
        stock
        images
        isActive
        createdAt
        updatedAt
        mainCategoryId
        subCategoryId
      }
    }
  }
`;

// 제품 목록 조회
export const GET_PRODUCTS = gql`
  query GetProducts($mainCategoryId: String, $subCategoryId: String, $isActive: Boolean, $limit: Int, $offset: Int) {
    products(mainCategoryId: $mainCategoryId, subCategoryId: $subCategoryId, isActive: $isActive, limit: $limit, offset: $offset) {
      products {
        id
        name
        description
        specifications
        price
        discountPrice
        stock
        images
        order
        isActive
        createdAt
        updatedAt
        mainCategoryId
        subCategoryId
        productCode
        size
        options
        mainCategory {
          id
          name
        }
        subCategory {
          id
          name
        }
      }
      totalCount
    }
  }
`;

// 기존 호환성을 위한 alias
export const GET_PRODUCTS_QUERY = GET_PRODUCTS;

// 특정 제품 조회
export const GET_PRODUCT = gql`
  query GetProduct($id: ID!) {
    product(id: $id) {
      id
      name
      description
      specifications
      price
      discountPrice
      stock
      images
      isActive
      createdAt
      updatedAt
      mainCategoryId
      subCategoryId
      productCode
      size
      options
      cadFiles {
        name
        url
        size
        type
      }
      pdfFiles {
        name
        url
        size
        type
      }
      mainCategory {
        id
        name
      }
      subCategory {
        id
        name
      }
      reviews {
        id
        rating
        content
        images
        isActive
        createdAt
        updatedAt
        user {
          id
          name
          email
        }
      }
    }
  }
`;

// 제품 검색
export const SEARCH_PRODUCTS = gql`
  query SearchProducts($query: String!, $limit: Int, $offset: Int) {
    searchProducts(query: $query, limit: $limit, offset: $offset) {
      products {
        id
        name
        description
        specifications
        price
        discountPrice
        stock
        images
        isActive
        createdAt
        updatedAt
        mainCategoryId
        subCategoryId
        mainCategory {
          id
          name
        }
        subCategory {
          id
          name
        }
      }
      totalCount
    }
  }
`;

// 메인 카테고리 생성
export const CREATE_MAIN_CATEGORY = gql`
  mutation CreateMainCategory($input: MainCategoryInput!) {
    createMainCategory(input: $input) {
      id
      name
      description
      bannerImage
      bannerUrl
      order
      isActive
      createdAt
      updatedAt
      subCategoryCount
      productCount
    }
  }
`;

// 기존 호환성을 위한 alias
export const CREATE_CATEGORY_MUTATION = CREATE_MAIN_CATEGORY;

// 메인 카테고리 업데이트
export const UPDATE_MAIN_CATEGORY = gql`
  mutation UpdateMainCategory($id: ID!, $input: MainCategoryInput!) {
    updateMainCategory(id: $id, input: $input) {
      id
      name
      description
      bannerImage
      bannerUrl
      order
      isActive
      createdAt
      updatedAt
      subCategoryCount
      productCount
    }
  }
`;

// 기존 호환성을 위한 alias
export const UPDATE_CATEGORY_MUTATION = UPDATE_MAIN_CATEGORY;

// 메인 카테고리 삭제
export const DELETE_MAIN_CATEGORY = gql`
  mutation DeleteMainCategory($id: ID!) {
    deleteMainCategory(id: $id)
  }
`;

// 기존 호환성을 위한 alias
export const DELETE_CATEGORY_MUTATION = DELETE_MAIN_CATEGORY;

// 하위 카테고리 생성
export const CREATE_SUB_CATEGORY = gql`
  mutation CreateSubCategory($input: SubCategoryInput!) {
    createSubCategory(input: $input) {
      id
      name
      description
      bannerImage
      bannerUrl
      order
      isActive
      createdAt
      updatedAt
      productCount
      mainCategory {
        id
        name
      }
    }
  }
`;

// 하위 카테고리 업데이트
export const UPDATE_SUB_CATEGORY = gql`
  mutation UpdateSubCategory($id: ID!, $input: SubCategoryInput!) {
    updateSubCategory(id: $id, input: $input) {
      id
      name
      description
      bannerImage
      bannerUrl
      order
      isActive
      createdAt
      updatedAt
      productCount
      mainCategory {
        id
        name
      }
    }
  }
`;

// 하위 카테고리 삭제
export const DELETE_SUB_CATEGORY = gql`
  mutation DeleteSubCategory($id: ID!) {
    deleteSubCategory(id: $id)
  }
`;

// 제품 생성
export const CREATE_PRODUCT = gql`
  mutation CreateProduct($input: ProductInput!) {
    createProduct(input: $input) {
      id
      name
      description
      specifications
      price
      discountPrice
      stock
      images
      isActive
      createdAt
      updatedAt
      mainCategoryId
      subCategoryId
      productCode
      size
      options
      cadFiles {
        name
        url
        size
        type
      }
      pdfFiles {
        name
        url
        size
        type
      }
      mainCategory {
        id
        name
      }
      subCategory {
        id
        name
      }
    }
  }
`;

// 제품 업데이트
export const UPDATE_PRODUCT = gql`
  mutation UpdateProduct($id: ID!, $input: ProductInput!) {
    updateProduct(id: $id, input: $input) {
      id
      name
      description
      specifications
      price
      discountPrice
      stock
      images
      isActive
      createdAt
      updatedAt
      mainCategoryId
      subCategoryId
      productCode
      size
      options
      cadFiles {
        name
        url
        size
        type
      }
      pdfFiles {
        name
        url
        size
        type
      }
      mainCategory {
        id
        name
      }
      subCategory {
        id
        name
      }
    }
  }
`;

// 제품 삭제
export const DELETE_PRODUCT = gql`
  mutation DeleteProduct($id: ID!) {
    deleteProduct(id: $id)
  }
`;

// 메인 카테고리 순서 벌크 업데이트
export const UPDATE_MAIN_CATEGORY_ORDERS = gql`
  mutation UpdateMainCategoryOrders($categoryOrders: [CategoryOrderInput!]!) {
    updateMainCategoryOrders(categoryOrders: $categoryOrders) {
      id
      name
      description
      bannerImage
      bannerUrl
      order
      isActive
      createdAt
      updatedAt
      subCategoryCount
      productCount
      subCategories {
        id
        name
        description
        bannerImage
        bannerUrl
        order
        isActive
        productCount
      }
    }
  }
`;

// 하위 카테고리 순서 벌크 업데이트
export const UPDATE_SUB_CATEGORY_ORDERS = gql`
  mutation UpdateSubCategoryOrders($categoryOrders: [CategoryOrderInput!]!) {
    updateSubCategoryOrders(categoryOrders: $categoryOrders) {
      id
      name
      description
      bannerImage
      bannerUrl
      order
      isActive
      createdAt
      updatedAt
      productCount
      mainCategory {
        id
        name
      }
    }
  }
`;

// 제품 순서 벌크 업데이트
export const UPDATE_PRODUCT_ORDERS = gql`
  mutation UpdateProductOrders($productOrders: [ProductOrderInput!]!) {
    updateProductOrders(productOrders: $productOrders) {
      id
      name
      description
      specifications
      price
      discountPrice
      stock
      images
      isActive
      order
      createdAt
      updatedAt
      mainCategoryId
      subCategoryId
      mainCategory {
        id
        name
      }
      subCategory {
        id
        name
      }
    }
  }
`; 